import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_account_balance_RowClass,
  bl_aat_claim_account_balance_RowInterface,
  bl_aat_claim_account_entitlement_employee_link_RowClass,
  bl_aat_claim_item_hdr_RowClass
} from '../../../dbschema';

export class ClaimItemCustomContainer extends BaseContainerModel {
  bl_aat_claim_item_hdr: bl_aat_claim_item_hdr_RowClass = new bl_aat_claim_item_hdr_RowClass();
  bl_aat_claim_account_entitlement_employee_link: bl_aat_claim_account_entitlement_employee_link_RowClass = new bl_aat_claim_account_entitlement_employee_link_RowClass();
  bl_aat_claim_account_balance: bl_aat_claim_account_balance_RowClass = new bl_aat_claim_account_balance_RowClass();
}
